import { useDispatch, useSelector } from 'react-redux'
import { useMutation } from '@apollo/client'
import { AppState } from '../root-reducer'
import { AffiliateTrackState } from './types'
import { AffiliateTrackAction } from './actions'
import { affiliateLinkClickCreateOne } from '../../graphql/AffiliateLinkClick/affiliateLinkClickCreateOne'
import useSegment from '../../components/utils/useSegment'

const useAffiliateTrack = () => {
  const dispatch = useDispatch()
  const { track } = useSegment()
  const { affiliate } = useSelector<AppState, AffiliateTrackState>((state) => state.affiliate)
  const [AffiliateLinkClickCreateOne] = useMutation(affiliateLinkClickCreateOne)

  const setAffiliate = async (affiliate: string) => {
    dispatch(AffiliateTrackAction(affiliate))
  }

  const trackLinkClick = async (affiliate: string) => {
    await AffiliateLinkClickCreateOne({ variables: { affiliate } })

    track('Clicked Affiliate Link', {
      affiliate,
      clicked_date: new Date()
    })
  }

  return {
    affiliate,
    actions: { setAffiliate, trackLinkClick }
  }
}

export default useAffiliateTrack
